<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M13.999999940395355,0C13.999999940395355,0,1.9999999403953552,0,1.9999999403953552,0C1.4499999403953552,0,0.9999999403953552,0.45,0.9999999403953552,1C0.9999999403953552,1,0.9999999403953552,15,0.9999999403953552,15C0.9999999403953552,15.55,1.4499999403953552,16,1.9999999403953552,16C1.9999999403953552,16,13.999999940395355,16,13.999999940395355,16C14.549999940395356,16,14.999999940395355,15.55,14.999999940395355,15C14.999999940395355,15,14.999999940395355,1,14.999999940395355,1C14.999999940395355,0.45,14.549999940395356,0,13.999999940395355,0C13.999999940395355,0,13.999999940395355,0,13.999999940395355,0ZM12.999999940395355,14C12.999999940395355,14,2.9999999403953552,14,2.9999999403953552,14C2.9999999403953552,14,2.9999999403953552,6,2.9999999403953552,6C2.9999999403953552,6,12.999999940395355,6,12.999999940395355,6C12.999999940395355,6,12.999999940395355,14,12.999999940395355,14C12.999999940395355,14,12.999999940395355,14,12.999999940395355,14ZM12.999999940395355,5C12.999999940395355,5,2.9999999403953552,5,2.9999999403953552,5C2.9999999403953552,5,2.9999999403953552,2,2.9999999403953552,2C2.9999999403953552,2,12.999999940395355,2,12.999999940395355,2C12.999999940395355,2,12.999999940395355,5,12.999999940395355,5C12.999999940395355,5,12.999999940395355,5,12.999999940395355,5Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'WidgetHeader',
} as DefineComponent
</script>
